import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-wound-derm',
  templateUrl: './wound-derm.component.html',
  styleUrls: ['./wound-derm.component.css']
})
export class WoundDermComponent implements OnInit {
  tabIndex = 0;
  activatedRouter: string = 'wound'
  company_id: string;
  constructor(
        private _route: ActivatedRoute,
  ) { 
        this.company_id = this._route.parent.snapshot.params.id;
  }

  ngOnInit(): void {
    
  }
  onTabClick(event) {
    if (event?.index == 0) {
      this.tabIndex = 0;
      this.activatedRouter = 'wound'
    }
    if (event?.index == 1) {
      this.tabIndex = 1;
      this.activatedRouter = 'derm'
    }
  }
}
